<template>
  <v-dialog v-model="abierto" max-width="1400" scrollable>
    <v-card>
      <v-card-title class="text-h6">
        <div>
          <div>{{ (detalle && detalle.nombre) || (anuncio && anuncio.ad_name) || 'Anuncio' }}</div>
          <div class="caption grey--text">
            {{ adId }}
            <span v-if="detalle"> · {{ detalle.campana || '-' }} › {{ detalle.conjunto || '-' }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip v-if="detalle && detalle.estado" small class="mr-2" :color="detalle.estado === 'ACTIVE' ? 'green lighten-4' : 'grey lighten-2'">
          {{ detalle.estado }}
        </v-chip>
        <v-btn small tile color="blue darken-2" dark class="mr-2" :disabled="!anuncio" @click="verProspectos">
          <v-icon left small>mdi-account-search</v-icon>
          Ver prospectos
        </v-btn>
        <v-btn small tile color="blue-grey darken-1" dark class="mr-2" :disabled="!detalle" @click="descargarJSON">
          <v-icon left small>mdi-code-json</v-icon>
          JSON
        </v-btn>
        <v-btn icon @click="abierto = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text>
        <div v-if="cargando" class="text-center py-8">
          <v-progress-circular indeterminate color="blue darken-2"></v-progress-circular>
          <div class="caption mt-2">Consultando histórico y Meta…</div>
        </div>
        <v-alert v-else-if="error" type="error" text dense>{{ error }}</v-alert>

        <template v-else-if="detalle">
          <div class="body-2 mb-2">
            Del <strong>{{ detalle.rango.desde }}</strong> al <strong>{{ detalle.rango.hasta }}</strong> ({{ detalle.rango.dias }} días)
            <span v-if="detalle.rango_anterior">
              · comparado con {{ detalle.rango_anterior.desde }} al {{ detalle.rango_anterior.hasta }}
            </span>
          </div>
          <v-alert v-for="(f, i) in detalle.calidad_datos.faltantes" :key="'f' + i" type="warning" text dense class="mb-1">{{ f }}</v-alert>

          <v-row class="mt-2">
            <!-- CREATIVO -->
            <v-col cols="12" md="4">
              <v-card outlined>
                <v-card-subtitle class="pb-1 font-weight-bold">Contenido</v-card-subtitle>
                <v-card-text v-if="!detalle.creativo">No disponible en Meta.</v-card-text>
                <v-card-text v-else>
                  <div class="d-flex mb-2">
                    <v-img v-if="detalle.creativo.miniatura_url" :src="detalle.creativo.miniatura_url" max-width="96" max-height="96" contain class="mr-3 grey lighten-4"></v-img>
                    <div class="caption">
                      <div><strong>Formato:</strong> {{ detalle.creativo.formato || '-' }}</div>
                      <div><strong>CTA:</strong> {{ detalle.creativo.cta || '-' }}</div>
                      <div><strong>Creativo:</strong> {{ detalle.creativo.creative_id }}</div>
                      <div v-if="detalle.creativos_historicos.length > 1">
                        <strong>Creativos en el histórico:</strong> {{ detalle.creativos_historicos.length }}
                      </div>
                      <a v-if="detalle.creativo.instagram_url" :href="detalle.creativo.instagram_url" target="_blank" rel="noopener">Ver publicación</a>
                    </div>
                  </div>
                  <div class="subtitle-2">{{ detalle.creativo.encabezado || '(sin encabezado)' }}</div>
                  <div class="body-2 texto-anuncio">{{ detalle.creativo.texto_principal || '(sin texto)' }}</div>
                  <v-expansion-panels v-if="variantes" flat class="mt-2">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="px-0 caption">
                        Variantes: {{ detalle.creativo.variantes_texto.length }} textos, {{ detalle.creativo.variantes_encabezado.length }} encabezados,
                        {{ detalle.creativo.variantes_imagen || 0 }} imágenes, {{ (detalle.creativo.variantes_video || []).length }} videos
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-for="(t, i) in detalle.creativo.variantes_encabezado" :key="'e' + i" class="subtitle-2">{{ t }}</div>
                        <v-divider class="my-2"></v-divider>
                        <div v-for="(t, i) in detalle.creativo.variantes_texto" :key="'t' + i" class="body-2 texto-anuncio mb-2">{{ t }}</div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>

              <v-card outlined class="mt-3">
                <v-card-subtitle class="pb-1 font-weight-bold">Periodo completo según Meta</v-card-subtitle>
                <v-card-text v-if="!detalle.periodo_meta">No disponible en Meta.</v-card-text>
                <v-card-text v-else class="caption">
                  <div><strong>Alcance:</strong> {{ entero(detalle.periodo_meta.alcance) }}</div>
                  <div><strong>Frecuencia:</strong> {{ decimal(detalle.periodo_meta.frecuencia) }}</div>
                  <div class="mt-1"><strong>Calidad:</strong> {{ ranking(detalle.periodo_meta.quality_ranking) }}</div>
                  <div><strong>Interacción:</strong> {{ ranking(detalle.periodo_meta.engagement_rate_ranking) }}</div>
                  <div><strong>Conversión:</strong> {{ ranking(detalle.periodo_meta.conversion_rate_ranking) }}</div>
                  <template v-if="detalle.periodo_meta.video_3s !== null">
                    <div class="mt-1"><strong>Video</strong> (sobre reproducciones de 3 s: {{ entero(detalle.periodo_meta.video_3s) }})</div>
                    <div>25 %: {{ entero(detalle.periodo_meta.video_p25) }} · 50 %: {{ entero(detalle.periodo_meta.video_p50) }} ·
                      75 %: {{ entero(detalle.periodo_meta.video_p75) }} · 100 %: {{ entero(detalle.periodo_meta.video_p100) }}</div>
                    <div>ThruPlay: {{ entero(detalle.periodo_meta.video_thruplay) }} · Tiempo promedio: {{ decimal(detalle.periodo_meta.video_seg_promedio) }} s</div>
                  </template>
                  <div v-else class="mt-1">Video: Meta no reporta reproducciones.</div>
                  <div v-if="detalle.periodo_meta_anterior" class="mt-2 grey--text">
                    Periodo anterior: alcance {{ entero(detalle.periodo_meta_anterior.alcance) }},
                    frecuencia {{ decimal(detalle.periodo_meta_anterior.frecuencia) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- INDICADORES -->
            <v-col cols="12" md="8">
              <v-row dense>
                <v-col v-for="k in kpis" :key="k.campo" cols="6" sm="4" lg="3">
                  <v-card outlined class="fill-height">
                    <v-card-text class="pa-2">
                      <div class="caption grey--text text--darken-1">{{ k.titulo }}</div>
                      <div class="subtitle-1 font-weight-bold">{{ formatear(detalle.totales[k.campo], k.formato) }}</div>
                      <div v-if="k.crm && detalle.totales[k.campo] === null && diasSinCrm" class="caption orange--text text--darken-3">
                        {{ diasSinCrm === detalle.diario.length ? 'Falta el CRM (no es cero)' : 'No calculable: faltan días del CRM' }}
                      </div>
                      <div v-if="detalle.totales_anterior" class="caption">
                        <span class="grey--text">Antes {{ formatear(detalle.totales_anterior[k.campo], k.formato) }}</span>
                        <span v-if="variacion(k.campo) !== null" :class="k.neutral ? 'grey--text text--darken-2' : claseVariacion(variacion(k.campo), k.invertir)">
                          {{ variacion(k.campo) > 0 ? '▲' : '▼' }} {{ Math.abs(variacion(k.campo)) }} %
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <div class="subtitle-2 mt-3">Evolución diaria <span class="caption grey--text">(línea: inversión por día)</span></div>
              <v-sparkline
                v-if="serieGasto.length > 1"
                :value="serieGasto"
                color="blue darken-2"
                line-width="2"
                smooth="4"
                padding="6"
                height="40"
                auto-draw
              ></v-sparkline>
              <v-data-table
                :headers="headersDiario"
                :items="filasDiario"
                item-key="fecha"
                dense
                class="elevation-0"
                :items-per-page="-1"
                hide-default-footer
                mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr :class="item.estado_dia === 'sin_historico' ? 'grey--text' : ''">
                    <td v-for="h in headersDiario" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                      {{ formatear(item[h.value], h.formato) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="subtitle-2 mt-3">Ubicaciones</div>
              <div v-if="!detalle.ubicaciones.length" class="caption grey--text">Sin desglose por ubicación para este rango.</div>
              <v-data-table
                v-else
                :headers="headersUbicacion"
                :items="detalle.ubicaciones"
                item-key="ubicacion"
                dense
                class="elevation-0"
                :items-per-page="-1"
                hide-default-footer
                mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td v-for="h in headersUbicacion" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                      {{ formatear(item[h.value], h.formato) }}
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="caption grey--text mt-3">
                <div v-for="(a, i) in detalle.calidad_datos.advertencias" :key="'a' + i">· {{ a }}</div>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { formatoMoneda, formatoEntero, formatoPct } from '@/helpers/meta-ads-definiciones'

  const ESTADO_DIA = { con_entrega: 'Con entrega', sin_entrega: 'Sin entrega', sin_historico: 'Sin histórico' }
  const RANKING = {
    ABOVE_AVERAGE: 'Arriba del promedio',
    AVERAGE: 'Promedio',
    BELOW_AVERAGE_35: 'Abajo del promedio (35 % inferior)',
    BELOW_AVERAGE_20: 'Abajo del promedio (20 % inferior)',
    BELOW_AVERAGE_10: 'Abajo del promedio (10 % inferior)',
  }

  export default {
    props: {
      idEscuela: { type: Number, required: true },
    },

    data: () => ({
      abierto: false,
      cargando: false,
      error: '',
      anuncio: null,
      detalle: null,
      kpis: [
        { titulo: 'Inversión', campo: 'gasto', formato: 'moneda', neutral: true },
        { titulo: 'Impresiones', campo: 'impresiones', formato: 'entero' },
        { titulo: 'CTR', campo: 'ctr', formato: 'pct' },
        { titulo: 'CPC (enlace)', campo: 'cpc', formato: 'moneda', invertir: true },
        { titulo: 'CPM', campo: 'cpm', formato: 'moneda', invertir: true },
        { titulo: 'Conversaciones', campo: 'conversaciones_meta', formato: 'entero' },
        { titulo: 'Costo / conversación', campo: 'costo_por_conversacion', formato: 'moneda', invertir: true },
        { titulo: 'Registros completos', campo: 'registros_completos', formato: 'entero', crm: true },
        { titulo: 'Nuevos completos', campo: 'nuevos_completos', formato: 'entero', crm: true },
        { titulo: 'Costo / nuevo completo', campo: 'costo_por_nuevo_completo', formato: 'moneda', invertir: true, crm: true },
        { titulo: 'Inscritos', campo: 'inscritos', formato: 'entero', crm: true },
        { titulo: 'Reproducciones 3 s / impresiones', campo: 'tasa_3s_pct', formato: 'pct' },
      ],
      headersDiario: [
        { text: 'Fecha', value: 'fecha', formato: 'texto' },
        { text: 'Estado', value: 'estado_texto', formato: 'texto' },
        { text: 'Inversión', value: 'gasto', formato: 'moneda', align: 'end' },
        { text: 'Impresiones', value: 'impresiones', formato: 'entero', align: 'end' },
        { text: 'Alcance', value: 'alcance', formato: 'entero', align: 'end' },
        { text: 'CTR', value: 'ctr', formato: 'pct', align: 'end' },
        { text: 'CPM', value: 'cpm', formato: 'moneda', align: 'end' },
        { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
        { text: 'Prospectos', value: 'prospectos', formato: 'entero', align: 'end' },
        { text: 'Completos', value: 'registros_completos', formato: 'entero', align: 'end' },
        { text: 'Nuevos completos', value: 'nuevos_completos', formato: 'entero', align: 'end' },
        { text: 'Inscritos', value: 'inscritos', formato: 'entero', align: 'end' },
      ],
      headersUbicacion: [
        { text: 'Ubicación', value: 'ubicacion', formato: 'texto' },
        { text: 'Inversión', value: 'gasto', formato: 'moneda', align: 'end' },
        { text: 'Impresiones', value: 'impresiones', formato: 'entero', align: 'end' },
        { text: 'CTR', value: 'ctr', formato: 'pct', align: 'end' },
        { text: 'CPC (enlace)', value: 'cpc', formato: 'moneda', align: 'end' },
        { text: 'CPM', value: 'cpm', formato: 'moneda', align: 'end' },
        { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
        { text: 'Días', value: 'dias', formato: 'entero', align: 'end' },
      ],
    }),

    computed: {
      adId () {
        return this.anuncio ? this.anuncio.ad_id : ''
      },

      variantes () {
        const c = this.detalle && this.detalle.creativo
        return !!c && (c.variantes_texto.length > 1 || c.variantes_encabezado.length > 1)
      },

      filasDiario () {
        if (!this.detalle) return []
        return this.detalle.diario.map((d) => {
          const crm = d.crm || {}
          return {
            ...d,
            estado_texto: (ESTADO_DIA[d.estado_dia] || d.estado_dia) + (d.crm ? '' : ' · sin CRM'),
            prospectos: d.crm ? crm.prospectos : null,
            registros_completos: d.crm ? crm.registros_completos : null,
            nuevos_completos: d.crm ? crm.nuevos_completos : null,
            inscritos: d.crm ? crm.inscritos : null,
          }
        })
      },

      diasSinCrm () {
        return this.detalle ? this.detalle.diario.filter((d) => !d.crm).length : 0
      },

      serieGasto () {
        return this.filasDiario.map((d) => Number(d.gasto) || 0)
      },
    },

    methods: {
      abrir (anuncio, { desde, hasta, comparar }) {
        this.anuncio = anuncio
        this.detalle = null
        this.error = ''
        this.abierto = true
        this.cargando = true
        return this.$http.post('api/meta/anuncio/' + this.idEscuela, { ad_id: anuncio.ad_id, desde, hasta, comparar })
          .then((response) => { this.detalle = response.data })
          .catch((error) => {
            const r = error.response
            this.error = (r && r.data && r.data.message) || 'No se pudo consultar el anuncio'
          })
          .finally(() => { this.cargando = false })
      },

      verProspectos () {
        this.abierto = false
        this.$emit('ver-prospectos', this.anuncio)
      },

      formatear (valor, formato) {
        if (formato === 'moneda') return formatoMoneda(valor)
        if (formato === 'entero') return formatoEntero(valor)
        if (formato === 'pct') return formatoPct(valor)
        return valor === null || valor === undefined || valor === '' ? '-' : valor
      },

      entero (v) {
        return formatoEntero(v)
      },

      decimal (v) {
        return v === null || v === undefined ? 'Sin dato' : Number(v).toLocaleString('es-MX', { maximumFractionDigits: 2 })
      },

      ranking (v) {
        return v ? (RANKING[v] || v) : 'Meta no lo calculó'
      },

      variacion (campo) {
        const v = this.detalle && this.detalle.variacion_pct
        return v && typeof v[campo] === 'number' ? v[campo] : null
      },

      claseVariacion (valor, invertir) {
        if (!valor) return 'grey--text'
        const mejora = invertir ? valor < 0 : valor > 0
        return mejora ? 'green--text text--darken-2' : 'red--text text--darken-2'
      },

      descargarJSON () {
        const blob = new Blob([JSON.stringify(this.detalle, null, 2)], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `anuncio_${this.adId}_${this.detalle.rango.desde}_${this.detalle.rango.hasta}.json`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },
    },
  }
</script>

<style scoped>
  .texto-anuncio {
    white-space: pre-wrap;
  }
</style>
